import { GridProps, Grid as MuiGrid } from "@mui/material";
import { SpacingProps } from "@mui/system";

type Props = SpacingProps & GridProps;

export const Grid: React.FC<Props> = ({ children, ...props }) => {
  return <MuiGrid {...props}>{children}</MuiGrid>;
};
